import React, { useState } from 'react'
import { useDispatch } from 'react-redux'

import { createAccount } from '../../Accounts/API'
import Checkmark from '../../../../img/check_mark_in_circle.svg'
import { setDialog as setDialogConnect } from '../../../actions/navigation'
import Modal from '../Modal'

export default () => {
    const [email, setEmail] = useState('')
    const [name, setName] = useState('')
    const [errorMessage, setErrorMessage] = useState('')
    const [userCreateSuccessful, setUserCreateSuccessful] = useState(false)

    const dispatch = useDispatch()
    const setDialog = dialogName => dispatch(setDialogConnect(dialogName))

    const handleSubmit = async event => {
        event.preventDefault()
        setErrorMessage('')

        try {
            await createAccount(email.toLowerCase(), name.trim())
        } catch (error) {
            if (error.response.status === 400) {
                setErrorMessage(error.response.data)
                return
            }
            throw error
        }

        setUserCreateSuccessful(true)
    }

    return (
        <Modal>
            <div className="form-modal create-account">
                <header>
                    <h2>Sign Up</h2>
                    <p>A Site Check account will allow you to easily save and share parcel search configurations.</p>
                </header>
                <form
                    className={userCreateSuccessful ? 'hide collapsible' : 'collapsible'}
                    method="post"
                    onSubmit={handleSubmit}
                >
                    {errorMessage && <p className="error">{errorMessage}</p>}
                    <label>
                        Name
                        <input autoFocus type="text" name="name" value={name} onChange={e => setName(e.target.value)} />
                    </label>
                    <label>
                        Email
                        <input type="text" name="email" value={email} onChange={e => setEmail(e.target.value)} />
                    </label>
                    <button type="submit" disabled={!email || !name.trim()} className="button is-primary">
                        Sign up
                    </button>
                </form>
                <div className={`success-message ${userCreateSuccessful ? '' : 'hide'}`}>
                    <div>
                        <Checkmark />
                        <p>
                            An email with further instructions has been sent to {email}. Please check your email to
                            finish signing up.
                        </p>
                    </div>
                </div>

                <p className="sign-up">
                    Already have an account?{' '}
                    <button type="button" onClick={() => setDialog('signIn')}>
                        Sign in.
                    </button>
                </p>
            </div>
        </Modal>
    )
}
